import styles from './section-info.module.css';
import { SectionInfoProps } from './section-info.props';

export const SectionInfo = ({ title, params }: SectionInfoProps) => {
	return (
		<div className={styles.wrapper}>
			<p className={styles.title}>{title}</p>
			<div className={styles.params}>
				{params.map(([key, value]) => (
					<div className={styles.param} key={key}>
						<p className={styles.key}>{key}</p>
						<p className={styles.value}>{value}</p>
					</div>
				))}
			</div>
		</div>
	);
};
